import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const uniqueBy =
  (select: (item: unknown) => unknown): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!Array.isArray(control.value)) {
      return {
        uniqueItems: true,
      };
    }

    const selected = control.value.map(select);
    const duplicates = selected.filter((value, index) => selected.indexOf(value) !== index);

    return duplicates.length === 0
      ? // Return null if validation passes
        null
      : { uniqueMembers: true };
  };

export const uniqueItems: ValidatorFn = uniqueBy((item) => item);
